const eurFormatter = new Intl.NumberFormat('be-BE', {
  style: 'currency',
  currency: 'EUR',
});

export function formatCentsToEUR(value?: number | null): string {
  if (!value) {
    return '€ 0,00';
  }

  return eurFormatter.format(value / 100);
}

export function formatCentsToString(value?: number): string {
  if (!value) {
    return '';
  }

  return (value / 100).toString();
}
